import React, { useEffect, useMemo, useState } from "react";

import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";

import { useRequestProcessor } from "../../requestProcessor";

import { useAtom } from "jotai";
import { ChatAtom, activeChildDetail } from "../../AtomStore/store";
import { SendMessage, fetchChat } from "../../QueryFunctions/queryfunction";

import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { StyledButton } from "./style";
import DateGroup from "./DateGroup";
import { FaSync } from "react-icons/fa";
import { Device } from "@capacitor/device";

const Conversation1 = () => {
  const [msg, setMsg] = useState("");
  const [startIndex, setStartIndex] = useState(0);
  const [moreData, setMoreData] = useState(true);
  const [chat, setChat] = useAtom(ChatAtom);
  const [loading, setLoading] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  const { useQueryWrapper, useMutationWrapper } = useRequestProcessor();

  const [activeChild] = useAtom(activeChildDetail);
  const { isFetching } = useQueryWrapper(
    ["Chat", "chat" + activeChild?.id, startIndex],
    async () => fetchChat(startIndex, setMoreData, chat, setChat),
    { keepPreviousData: true }
  );

  useEffect(() => {
    const checkDevice = async () => {
      const info = await Device.getInfo();
      setIsIOS(info.platform === "ios");
    };
    checkDevice();
  }, []);

  const updateState = (msg) => {
    const newItem = {
      message: msg.trim(),
      who: "parent",
      time: moment().format("hh:mm A"),
    };
    const updatedChat = Array.isArray(chat) ? [...chat] : [];
    const today = moment().format("DD-MM-YYYY");

    const existingDateGroupIndex = updatedChat.findIndex(
      (item) => item.dateGroup === today
    );

    if (existingDateGroupIndex !== -1) {
      updatedChat[existingDateGroupIndex].data.push(newItem);
      setChat(updatedChat);
    } else {
      // updatedChat.push({ dateGroup: today, data: [newItem] });
      setChat([
        { dateGroup: today, data: [newItem] },
        ...(Array.isArray(chat) ? chat : []),
      ]);
    }
  };
  const send = useMutationWrapper("SendMessage", () =>
    SendMessage(msg, updateState)
  );

  useMemo(() => {
    console.log(
      `[Conversations] Fetching Conversations details for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  // const fetch = () => {
  //   const startIndex = 0;
  //   setStartIndex(startIndex);
  // };

  const fetchMoreData = () => {
    const Index = startIndex + 50 + 1;
    setStartIndex(Index);
  };

  const scrollToBottom = () => {
    const chatContainer = document.getElementById("chat-container");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  const handleRefresh = () => {
    setLoading(true);
    fetchChat(0, setMoreData, chat, setChat).finally(setLoading(false));
    scrollToBottom();
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  console.log("Chat", chat);
  return (
    <div className=" w-full relative">
      {isFetching || loading ? <SpinnerLoading /> : <></>}
      {send.isLoading ? <SpinnerLoading /> : <></>}

      <div
        className="border border-[#21C1E0] shadow-md bg-header bg-opacity-90 rounded-full w-30 h-10 absolute mx-auto inset-4 flex items-center justify-center gap-2"
        onClick={handleRefresh}
      >
        <FaSync color="white" />
        <p className="text-white font-medium">Refresh</p>
      </div>

      <div
        className={`relative bg-[#eaf3fa] overflow-y-auto px-3 pb-25 ${
          isIOS ? "h-[calc(100vh-210px)]" : "h-[calc(100vh-190px)]"
        }`}
        id="chat-container"
        style={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column-reverse",
          scrollBehavior: "smooth",
        }}
      >
        {/* Chat content */}
        {Array.isArray(chat) && (
          <InfiniteScroll
            dataLength={chat?.length}
            next={fetchMoreData}
            style={{ display: "flex", flexDirection: "column-reverse" }}
            inverse={true}
            hasMore={moreData}
            scrollableTarget="chat-container"
          >
            {[...chat]?.map((dateGroup, index) => (
              <DateGroup key={index} dateGroup={dateGroup} />
            ))}
          </InfiniteScroll>
        )}

        {!Array.isArray(chat) ||
          (chat.length === 0 && (
            <ListEmptyComponent
              heading={
                this.props.loading ? "Loading..." : "Conversation list is Empty"
              }
            />
          ))}

        {/* Bottom fixed div */}
        {/* <div className=" fixed md:bottom-6 md:right-14 bg-[#eaf3fa] h-20  w-[50vw] sm:right-5 sm:bottom-12 xs:bottom-12 xs:right-5"></div>
  <div className=" fixed md:bottom-6 md:left-80 bg-[#eaf3fa] h-20  w-[50vw] sm:left-0 sm:bottom-12 xs:bottom-12"></div> */}
      </div>

      <div
        className={`h-15 flex px-4 pb-2 fixed ${
          isIOS ? "bottom-[60px]" : "bottom-[70px]"
        }  left-0 md:left-70 right-0 bg-[#eaf3fa]`}
      >
        <input
          style={{ zIndex: 0 }}
          className="col-span-10 border-1  rounded-2xl px-4 w-[95%]"
          type="textarea"
          placeholder="Type a message"
          value={msg}
          onChange={(event) => {
            event.preventDefault();
            setMsg(event.target.value);
          }}
        />
        <div
          className="col-span-2 flex items-center"
          addontype="prepend"
          style={{ alignItems: "center", zIndex: 0 }}
        >
          <StyledButton
            onClick={(e) => {
              e.preventDefault();
              scrollToBottom();
              if (typeof msg !== "undefined" && msg.length > 0) {
                send.mutate();
              }
              setMsg("");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 24 24"
              stroke=""
              className="size-12 text-black/80 ml-2"
            >
              <path
                fill="currentColor"
                d="M3 20V4l19 8zm2-3l11.85-5L5 7v3.5l6 1.5l-6 1.5zm0 0V7z"
              />
            </svg>
          </StyledButton>
        </div>
      </div>
    </div>
  );
};

export default Conversation1;
